import CustomerTableSimpleView from './CustomerTableSimpleView'
export default CustomerTableSimpleView
